import React from 'react';
import { Link } from 'gatsby';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import * as routes from '../../shared/routes';
import gif404 from '../../skin/images/landing/404.gif';
import { ArrowLeft } from '../../skin';
import './NotFound.scss';

const NotFound = () => (
  <div className="NotFound">
    <LazyLoadImage src={gif404} alt="404" />
    <p className="NotFound-textStrong">
      Ups,
      <br /> la página que buscas no existe.
    </p>
    <p className="NotFound-desc">
      Vuelve a tu{' '}
      <a className="Link" href={routes.CBO}>
        área personal
      </a>{' '}
      y consulta tus solicitudes o{' '}
      <Link className="Link" to={routes.HOME}>
        pide un préstamo
      </Link>{' '}
      con QueBueno en sólo 10 minutos.
    </p>

    <div>
      <Link className="Link NotFound-textStrong" to={routes.HOME}>
        <ArrowLeft className="NotFound-icon" />
        volver
      </Link>
    </div>
  </div>
);

export default NotFound;
